import { DOMRouteHandler } from './DOMRouteHandler';
import { initFilter } from '../modules/shopAllFilter';
import { initSnapScrollNavigation } from '../modules/scroll-snap-navigation';

export class TemplatePageShopAll extends DOMRouteHandler {
  static init(): void {
    customLocationChangeEvent();
    initFilter();
    initSnapScrollNavigation(document.querySelectorAll('[data-controls]'));
  }
}

function customLocationChangeEvent(): void {
  const oldPushState = window.history.pushState;
  window.history.pushState = function pushState(...args) {
    const ret = oldPushState.apply(this, args);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
  };

  const oldReplaceState = window.history.replaceState;
  window.history.replaceState = function replaceState(...args) {
    const ret = oldReplaceState.apply(this, args);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
  };

  window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'));
  });
}
